$(document).ready(function () {
    $(".a-switch__checkbox").click(function () {
        window.location.href = $(this).attr("data-vat-toggle");
    });

    var readCookie = Cookies.get("alert-close");
    if (!readCookie || readCookie !== "no") {
        $("#covid-alert").show();
        $("#covid-alert .close-button").click(function () {
            $("#covid-alert").hide();
            Cookies.set("alert-close", "no", { expires: 30 });
        });
    }

    $(".accordion").on("down.zf.accordion", function (e, $panel) {
        Foundation.reInit("equalizer");
    });

    $(".menu-close").click(function () {
        $("body").removeClass("pushy-open-left");
    });

    $(".dropdown-button").hover(
        function () {
            $(this).addClass("show");
        },
        function () {
            $(this).removeClass("show");
        },
    );

    $(".enter-address").click(function (e) {
        e.preventDefault();
        $(this).parents(".login__address").toggleClass("show");
    });

    if ($("#gmap").length > 0) {
        var lat = $("#gmap").attr("lat");
        var lng = $("#gmap").attr("long");

        new Maplace({
            locations: [
                {
                    lat: lat,
                    lon: lng,
                    zoom: 15,
                    icon: $(document.body).data("base") + "/images/site/map-icon.png",
                },
            ],
            controls_on_map: false,
            map_div: "#gmap",
        }).Load();
    }

    $(".bundle__product-title").click(function () {
        $(this).parents(".bundle__section--max-height").toggleClass("open");
    });

    $(".filter__title").click(function () {
        $(this).parents(".filter__list-item").toggleClass("open");
    });

    $(".filter__dropdown-title").click(function () {
        $(this).parents(".filter__dropdown").toggleClass("open");
    });

    $(".readmore").readmore({
        moreLink: '<a class="filter__readmore filter__readmore--more" href="#">More</a>',
        lessLink: '<a class="filter__readmore filter__readmore--less" href="#">Less</a>',
        collapsedHeight: 124,
    });

    $(".different-address").click(function () {
        $(".checkout__different-address").toggleClass("checkout__different-address--show");
    });

    $(".cart__quantity").click(function () {
        var $this = $(this);
        var $quantityElement = $this.siblings('input[type="text"].form__input--quantity');
        var $quantity = parseInt($quantityElement.val());

        if ($this.hasClass("cart__quantity--plus")) {
            $quantity++;
        } else {
            $quantity--;
        }

        if ($quantity < 0) {
            $quantity = 0;
        }

        $quantityElement.val($quantity).trigger("change");
    });

    $(".remove-customisation").click(function (e) {
        e.preventDefault();
        $(this).parents(".customisation").fadeOut().remove();
    });

    $(".remove-product").click(function (e) {
        e.preventDefault();
        $(this).parents(".product").fadeOut().remove();
    });

    $(".toggle a").click(function (e) {
        e.preventDefault();
        var para = $(this).closest("p");
        var initialHeight = $(this).closest("p").innerHeight();
        para.find(".read-more").show();
        para.find(".toggle").hide();
        var newHeight = para.innerHeight();
        para.css("max-height", initialHeight + "px");
        para.animate({ maxHeight: newHeight }, 300, function () {
            para.css("max-height", "none");
        });
    });

    $(".listing__wishlist").click(
        function () {
            $(this).addClass("added");
        },
        function () {
            $(this).removeClass("added");
        },
    );

    $(".options").click(function () {
        $(this).toggleClass("customise__selected");
    });

    $(".customise__list-item:not(.customise__list-item--unavailable)").click(function () {
        $(this).toggleClass("selected");
    });

    $(".account__button--view-all").click(function (e) {
        e.preventDefault();

        var $button = $(this);
        var $ordersBody = $(".account__orders-body");
        var currentOffset = parseInt($button.data("offset")) || 1;
        var limit = 5; // Number of orders to load per request

        // Disable button and show loading state
        $button.prop("disabled", true).text("Loading...");

        $.ajax({
            type: "POST",
            url: $(document.body).data("base") + "/ajax/account/load-more-orders.php",
            data: {
                offset: currentOffset,
                limit: limit,
            },
            success: function (response) {
                try {
                    // jQuery automatically parses JSON if Content-Type is application/json
                    // So response is already an object, not a string
                    var data = typeof response === "string" ? JSON.parse(response) : response;

                    if (data.status === "success") {
                        // Append new orders HTML
                        $ordersBody.append(data.html);

                        // Update offset for next request
                        currentOffset = data.nextOffset;
                        $button.data("offset", currentOffset);

                        // Hide button if no more orders
                        if (!data.hasMore) {
                            $button.remove();
                        } else {
                            // Re-enable button
                            $button.prop("disabled", false).text("View More");
                        }
                    } else {
                        // Error handling
                        console.error("Error loading orders:", data.message);
                        $button.prop("disabled", false).text("View More");
                        alert("Sorry, there was an error loading more orders. Please try again.");
                    }
                } catch (e) {
                    console.error("Error parsing response:", e, "Response was:", response);
                    $button.prop("disabled", false).text("View More");
                    alert("Sorry, there was an error loading more orders. Please try again.");
                }
            },
            error: function (xhr, status, error) {
                console.error("Ajax request failed:", {
                    status: status,
                    error: error,
                    response: xhr.responseText,
                });
                $button.prop("disabled", false).text("View More");
                alert("Sorry, there was an error loading more orders. Please try again.");
            },
        });
    });

    $(".wishlist__remove-all").click(function () {
        $(".wishlist__list-item").fadeOut();
    });

    $(".text").click(function (e) {
        e.preventDefault();
        $(".customise__option--upload").removeClass("show");
        $(".customise__option--text").addClass("show");
        $(".upload").removeClass("customise__selected");
    });

    $(".upload").click(function (e) {
        e.preventDefault();
        $(".customise__option--upload").addClass("show");
        $(".customise__option--text").removeClass("show");
        $(".text").removeClass("customise__selected");
    });

    if ($(".trustpilot-widget").length && $(window).width() < 1060) {
        $(".trustpilot-widget").children("iframe").css("width", "100%");
    }

    $(window).resize(function () {
        if ($(window).width() < 1060 && $(".trustpilot-widget").length) {
            $(".trustpilot-widget").children("iframe").css("width", "100%");
        } else {
            $(".trustpilot-widget").children("iframe").css("width", "420px");
        }

        if ($(window).width() < 1200) {
            $(".customise__right").removeClass("sidebar");
            // location.reload();
        }
    });

    $("ul.faq__accordion li").first().delay(1000).addClass("is-active");
    $("ul.faq__accordion li").first().delay(1000).children().show();

    /*START PREDICTIVE SEARCH*/
    //setup before functions
    var typingTimer; //timer identifier
    var doneTypingInterval = 500; //time in ms (5 seconds)
    //on keyup, start the countdown
    $(".input-search").keyup(function () {
        clearTimeout(typingTimer);
        if ($(".input-search").val()) {
            typingTimer = setTimeout(doneTyping, doneTypingInterval);
        }
    });

    // $('.homepage:not(.search)').click(function(){
    //     $('.search').slideUp('slow');
    // });
    //user is "finished typing," show search
    function doneTyping() {
        $.ajax({
            type: "POST",
            url: $(document.body).data("base") + "/ajax/predictive-search.php",
            data: "search=" + $(".input-search").val(),
            success: function (data) {
                $(".search").slideUp("slow");
                if (data != "") {
                    $(".products ul").remove();
                    var $response = JSON.parse(data);
                    var obj = $response.results,
                        ul = $("<ul>");
                    for (var i = 0, l = obj.length; i < l; ++i) {
                        ul.append("<li>" + "<a href='" + obj[i].url + "' class='image'> <img src='" + obj[i].image + "' alt='" + obj[i].name + "'></a>" + "<div class='text'><a href='" + obj[i].url + "' class='name'>" + obj[i].name + "</a><div class='price'>£" + obj[i].price + "</div></div>" + "</li>");
                    }
                    $(".products").append(ul);
                    $(".show-all").html("<a href='" + $(document.body).data("base") + "/c_workwear-and-uniforms?keyword_search=" + $response.display_search_term + "'>Show all results for: '<span>" + $response.display_search_term + "</span>'</a>");
                    $(".search").slideDown("slow");
                }
            },
            error: function () {
                console.log("Ajax request not received");
            },
        });
    }
    /*END PREDICTIVE SEARCH*/

    //email a friend product page
    var $email_friend = $('form[name="email_to_friend"]');
    $email_friend.validate({
        rules: {
            email: {
                required: true,
                uniqueEmail: true,
                email: true,
            },
        },
        submitHandler: function () {
            $.ajax({
                type: "POST",
                url: $(document.body).data("base") + "/ajax/email_product_to_friend.php",
                data: $email_friend.serialize(),
                success: function (response) {
                    response = JSON.parse(response);

                    swal({
                        title: "Success!",
                        text: response.message,
                        type: "success",
                        confirmButtonColor: "#f15a24",
                    });
                },
                error: function () {
                    console.log("Ajax request not received");
                },
            });

            return false;
        },
    });

    //leave a review product page
    $('form[name="product-leave-a-review"]').validate({
        errorClass: "form__label form__label--error",
        ignore: ".ignore",
        rules: {
            title: {
                required: true,
            },
            text: {
                required: true,
            },
            product: {
                required: true,
            },
        },
        errorPlacement: function (error, element) {
            error.insertBefore(element);
        },
        submitHandler: function () {
            $.ajax({
                type: "POST",
                url: $(document.body).data("base") + "/ajax/product/review.php",
                data: $('form[name="product-leave-a-review"]').serialize(),
                success: function (response) {
                    response = JSON.parse(response);

                    if (response.status !== "success") {
                        swal({
                            title: response.title,
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24",
                        });
                    } else {
                        swal(
                            {
                                title: response.title,
                                text: response.message,
                                type: response.status,
                                confirmButtonColor: "#f15a24",
                            },
                            function () {
                                if (response.status == "success") {
                                    // $('form[name="product-leave-a-review"]').find('input[type="text"], textarea').val('');
                                    $("#product_review").foundation("close");
                                }
                            },
                        );
                    }
                },
                error: function () {
                    console.log("Ajax request not received");
                },
            });

            return false;
        },
    });
    $(".rating__star--review").on("click, mouseover", function () {
        var $rating = $(this).attr("value");

        $(".rating__star--review").addClass("disabled");
        for (var $star = 1; $star <= $rating; $star++) {
            $(".rating__star--review")
                .eq($star - 1)
                .removeClass("disabled");
        }

        $(this).parent().siblings('input[name="rating"]').val($rating);
    });

    // $("#currency_select").on("change", function() {
    //     document.forms.currency_select_form.submit();
    // });
    // $("#vat_select").on("change", function() {
    //     document.forms.vat_select_form.submit();
    // });

    $(".top-sellers__star").on("click", function () {
        $(this).toggleClass("top-sellers__star--active");
    });

    $(".match-height").matchHeight();
    $(".match-height-text").matchHeight();
});

function updateSelectedColour() {
    var $active = $(".choose-product-colour li.active");
    var activeColour = $active.length ? $active.data("colourname") : "";
    $(".selected-colour span").text(activeColour || "Select colour");
}

function changeProductDetails(colourID) {
    if (colourID == undefined || colourID == null) {
        return;
    }
    var isMobile = $(document.body).data("ismobile");

    var productColourID = colourID; //colour id
    var productID = $('input[name="product_id"]').val(); //product id
    var colourInput = $('input[name="chosen_colour"]');
    var sizesList = $(".detail__sizes .sizes_to_change");

    //Go through each colour and remove active class if set
    $(".choose-product-colour li").each(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active"); // Only remove 'active' instead of all classes
        }
    });

    $('.choose-product-colour li[data-colourid="' + productColourID + '"]').addClass("active"); //Add active class to the colour clicked

    // Update selected colour text
    updateSelectedColour();

    $.ajax($(document.body).data("base") + "/ajax/product/product-colour-changes.php?colourid=" + productColourID + "&productid=" + productID + "").done(function (result) {
        var $response = JSON.parse(result);

        if ($response.from_price) {
            $(".total .price .price-figure").html($response.from_price);
        }

        if ($response.breakpoints) {
            $("#pbsl").html($response.breakpoints);
        }

        //change detail page based on whats returned
        colourInput.val(productColourID);
        sizesList.html($response["sizes"]);

        //Weve changed the sizes so lets run function to update prices
        sizeChange();

        //listen to change of size values on newly added items - run function to change price
        $(".sizes_to_change .form__input--sizes").on("change", function () {
            sizeChange();
        });
    });
}

//change product image when colour selected
$(".choose-product-colour li").on("click", function () {
    // var slideId = $(this).data('slideid');
    var colourID = $(this).data("colourid");

    //get slideID from gallery
    var $matchingImages = $('.site-slider__detail-small img[data-colourid="' + colourID + '"]');
    var $nonCloned = $matchingImages
        .filter(function () {
            return !$(this).closest(".slick-slide").hasClass("slick-cloned");
        })
        .first();
    var $img = $nonCloned.length ? $nonCloned : $matchingImages.first();
    var slideId = $img.closest(".slick-slide").data("slick-index");

    if (typeof slideId !== "undefined" && slideId !== null) {
        //change slide which in turn will run out beforeChange event...
        $(".site-slider__detail-small").slick("slickGoTo", slideId);
    } else {
        //make current active
        changeProductDetails(colourID);
    }
});

// Run on page load to set the correct initial color
updateSelectedColour();
//mobile for when colour selected
// $('.detail__colour--mobile select[name="chosen_colour"]').on('select2:select', function (e) {
//     var slideId = $('.detail__colour--mobile select[name="chosen_colour"]').find(':selected').data('slideid');
//     //change slide which in turn will run out beforeChange event...
//     $('.site-slider__detail-small').slick('slickGoTo', slideId);
// });

//Product detail slick carousel change - to have same functionality as function above
$(".site-slider__detail-small").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var slideID = nextSlide;
    var parentSlider = $(".site-slider__detail-small .slick-track");
    var elementImage = parentSlider.find(".slick-slide[data-slick-index=" + slideID + "]").find("img"); //find next slides image
    var $nextInnerSlide = parentSlider
        .find(".slick-slide[data-slick-index=" + slideID + "]")
        .find(".slide")
        .first();
    var $currentInnerSlide = parentSlider
        .find(".slick-slide[data-slick-index=" + currentSlide + "]")
        .find(".slide")
        .first();

    if (!$nextInnerSlide.hasClass("dont-change") && !$currentInnerSlide.hasClass("dont-change")) {
        //If current or next slide should change (as neither have the dont-change class)
        changeProductDetails(elementImage.data("colourid"));
    }
});

//listen to change of size values to update prices
$(document).on("change", ".form__input--sizes", function (e) {
    sizeChange();
});

$('form[name="checkout-delivery"]').validate({
    errorPlacement: function (error, element) {
        /* Need to add this function to remove the error default placement */
    },
    ignore: ".ignore",
    rules: {
        "delivery[email]": {
            required: true,
            email: true,
        },
        "delivery[first_name]": {
            required: true,
        },
        "delivery[last_name]": {
            required: true,
        },
        "delivery[address][line_one]": {
            required: true,
        },
        "delivery[address][city]": {
            required: true,
        },
        "delivery[address][postcode]": {
            required: true,
        },
        "delivery[address][country]": {
            required: true,
        },
    },
    submitHandler: function () {
        $.ajax({
            type: "POST",
            url: $(document.body).data("base") + "/ajax/product/checkout-stage-1.php",
            data: $('form[name="checkout-delivery"]').serialize(),
            success: function (response) {
                response = JSON.parse(response);
                window.location.href = $(document.body).data("base") + "/payment";
            },
            error: function () {
                console.log("Ajax request not received");
            },
        });

        return false;
    },
});

$('form[name="checkout-payment-form"]').validate({
    errorPlacement: function (error, element) {
        /* Need to add this function to remove the error default placement */
    },
    ignore: ".ignore",
    rules: {
        "invoice[email]": {
            required: "#different:unchecked",
        },
        "invoice[first_name]": {
            required: "#different:unchecked",
        },
        "invoice[last_name]": {
            required: "#different:unchecked",
        },
        "invoice[address][line_one]": {
            required: "#different:unchecked",
        },
        "invoice[address][city]": {
            required: "#different:unchecked",
        },
        "invoice[address][postcode]": {
            required: "#different:unchecked",
        },
        "invoice[address][country]": {
            required: "#different:unchecked",
        },
    },
    submitHandler: function () {
        $.ajax({
            type: "POST",
            url: $(document.body).data("base") + "/ajax/product/checkout-stage-2.php",
            data: $('form[name="checkout-payment-form"]').serialize(),
            success: function (response) {
                response = JSON.parse(response);
                window.location.href = $(document.body).data("base") + "/confirmation";
            },
            error: function () {
                console.log("Ajax request not received");
            },
        });

        return false;
    },
});

//proceed to payment
$(".proceed-to-payment-btn").on("click", function (e) {
    $(this).after('<img class="loading" width="30" style="margin-top: 59px;" src="' + $(document.body).data("base") + '/images/site/loading.gif">');
    e.preventDefault();
    $.ajax($(document.body).data("base") + "/ajax/product/proceed-to-payment.php").done(function (response) {
        response = JSON.parse(response);

        if (response.status !== "success") {
            $(".loading").remove();
            swal({
                title: "",
                text: response.message,
                type: response.status,
                confirmButtonColor: "#f15a24",
            });
            return;
        }

        if (response.redirect) {
            window.location.href = response.redirect;
        } else {
            window.location.href = $(document.body).data("base") + "/stripe-payment";
        }
    });
});

function sizeChange() {
    var productid = $('input[name="product_id"]').val();

    var total = 0;
    var sizes = {};

    $('.sizes_to_change input[type="number"]').each(function () {
        var qty = parseInt($(this).val()) || 0;
        var name = $(this).attr("name"); // e.g. "sizes[2267]"

        total += qty;

        if (qty > 0) {
            // Extract ID from "sizes[2267]"
            var sizeId = name.match(/\[(\d+)\]/);
            if (sizeId && sizeId[1]) {
                sizes[sizeId[1]] = qty;
            }
        }
    });

    if (total == 0) {
        total = 1;
    }

    // Pass total, productid, and the sizes object (which jQuery will serialize as size_id[ID]=qty)
    $.ajax({
        url: $(document.body).data("base") + "/ajax/product/price-breaks.php",
        data: {
            total: total,
            productid: productid,
            colourid: $(document).find("li.active[data-colourid]").data("colourid"),
            sizes: sizes,
        },
        success: function (result) {
            var $response = JSON.parse(result);

            // Update price on page
            $(".total .price .price-figure").text($response["price_plain"]);
            $(".total .price").data("original", $response["price_plain"]);

            // Re-render PayPal Pay Later banner (only if PayPal SDK is loaded)
            if (typeof paypal !== "undefined" && typeof paypal.Messages === "function") {
                var $paypalContainer = $("#paypal-message-container");
                $paypalContainer.empty();

                var $newBanner = $("<div></div>").attr("data-pp-message", "").attr("data-pp-style-layout", "flex").attr("data-pp-style-ratio", "8x1").attr("data-pp-style-color", "blue").attr("data-pp-amount", $response["price_plain"]).addClass("detail__paypal_paylater");

                $paypalContainer.append($newBanner);

                paypal.Messages().render($newBanner[0]);
            }
        },
    });
}

$('form[name="quick_search"]').validate({
    errorPlacement: function (error, element) {
        /* Need to add this function to remove the error default placement */
    },
    ignore: ".ignore",
    submitHandler: function () {
        $.ajax({
            type: "POST",
            url: $(document.body).data("base") + "/ajax/quick-search.php",
            data: $('form[name="quick_search"]').serialize(),
            success: function (response) {
                response = JSON.parse(response);
                window.location.href = response.redirect_url;
            },
            error: function () {
                console.log("Ajax request not received");
            },
        });

        return false;
    },
});

$(".brands__letter").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("disabled")) {
        return false;
    }

    $(".brands__letter").removeClass("active");
    $(this).addClass("active");

    if ($(this).data("letter") == "ALL") {
        $(".brands__list-item").show();
    } else if ($.isNumeric($(this).data("letter"))) {
        $(".brands__list-item").hide();

        for (var i = 0; i <= 9; i++) {
            $('.brands__list-item[data-block-letter="' + i + '"]').show();
        }
    } else {
        $(".brands__list-item").hide();
        $('.brands__list-item[data-block-letter="' + $(this).data("letter") + '"]').show();
    }
});
